/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { containerStyles, partnerSpeaksStyles } from "./styles";
import { responsiveStyles, singleSectionStyles } from "../../commons/styles";
import {
  ResponsiveWidget,
  ResponsiveWidgetItem,
} from "../../components/ResponsiveWidget";
import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import {
  PropValuesEnum,
  joiningReasonsHeading,
  joiningReasons,
  joinUsNowText,
  color,
  LandingPagedata,
  listOfPartners,
  buttonActions,
  GAEvents,
} from "../../constants/commons";
import { SignUpModal } from "../../modals/SignUpModal";
import { PartnersSpeak } from "../../components/PartnersSpeak";
import { FeesGuidelines } from "../../components/FeesGuidelines";
import { JoiningSteps } from "../../components/JoiningSteps";
import { Link } from "react-router-dom";
import { FAQ, FAQCategoryEnum } from "../../components/FAQ";
import { GA_Event } from "../../utils/reactGA";

interface ILandingPageProps {}

export const LandingPage: React.FC<ILandingPageProps> = (
  props: ILandingPageProps
) => {
  const [modalType, setmodalType] = React.useState<string>();
  const isMobile = useIsMobile();
  const isTablet = useIsTab();
  const [openSignUpModal, setOpenSignUpModal] = React.useState<boolean>(false);
  const onButtonClickAction = (clickType: string) => {
    setmodalType(clickType);
    setOpenSignUpModal(true);
  };

  const handleCancelModal = () => {
    setOpenSignUpModal(false);
  };
  const getJoiningReasons = () => {
    return joiningReasons.map((item, key) => {
      return (
        <ResponsiveWidgetItem cardView key={key}>
          <img src={require(`../../assets/${item.icon}`)} alt="" />
          <div>
            <h5>{item.heading}</h5>
            <div className="text-container">{item.description}</div>
          </div>
        </ResponsiveWidgetItem>
      );
    });
  };

  const getPartnersAvailableStyle = listOfPartners.map((data, key: number) => {
    let containerClass =
      key === 6 || key === 7 ? "p-1 col-6 col-sm-4" : "col-6 p-1 col-md-4";
    return (
      <div className={containerClass} key={key}>
        <Link to={data.link}>
          <img
            src={isMobile ? data.mobileImgLink : data.imgLink}
            alt=""
            width="100%"
            className="partner-img-style"
          />
        </Link>
      </div>
    );
  });

  const responsiveVideoCarousel = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1450 },
      items: 1,
      partialVisibilityGutter: 0,
    },
    desktop: {
      breakpoint: { max: 1450, min: 1170 },
      items: 1,
      partialVisibilityGutter: 0,
    },
    smallDesktop: {
      breakpoint: { max: 1170, min: 885 },
      items: 1,
      partialVisibilityGutter: 0,
    },
  };

  return (
    <section css={[containerStyles, responsiveStyles]}>
      {openSignUpModal && (
        <SignUpModal
          visible={openSignUpModal}
          handleCancel={handleCancelModal}
          modalType={modalType}
        />
      )}

      <div className="container-fluid  page-margin-container p-0">
        <div className="row no-gutters">
          <div className="col">
            <div className="responsive-partner-heading my-2 mx-2">
              {LandingPagedata["heading"]}
            </div>
            <div className="responsive-partner-short-heading mx-2">
              {LandingPagedata["subHeading"]}
            </div>
            <div className="responsive-partner-short-heading mx-2">
              {LandingPagedata["subHeadingHashTag"]}
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <button
                className="button-style-red responsive-button-width user-button-style my-3"
                onClick={() => {
                  GA_Event(
                    GAEvents.JOIN_US_NOW,
                    "clicked",
                    "from Landing page"
                  );
                  onButtonClickAction(buttonActions.SIGNUP);
                }}
              >
                <span className="responsive-text">{joinUsNowText}</span>
              </button>
            </div>
            <div className="row no-gutters mx-2 my-3">
              <div className="row no-gutters justify-content-center mb-4 responsive-margin-landingpage">
                {getPartnersAvailableStyle}
              </div>
            </div>
          </div>
        </div>
        <div className="single-section" css={singleSectionStyles()}>
          <div className="header-container  mb-4">
            <h5>{joiningReasonsHeading}</h5>
          </div>
          <ResponsiveWidget
            align={PropValuesEnum.HORIZONTAL}
            className="data-container"
          >
            {getJoiningReasons()}
          </ResponsiveWidget>
        </div>
        <div className="single-section" css={singleSectionStyles(color.white)}>
          <JoiningSteps heading="How it works" />
        </div>
        <div
          className={`single-section ${isMobile || isTablet ? "" : "px-0"}`}
          css={[
            singleSectionStyles(),
            partnerSpeaksStyles(isMobile || isTablet ? true : false),
          ]}
        >
          <PartnersSpeak
            carouselViewBreakpoints={responsiveVideoCarousel}
            profession={""}
          />
        </div>
        <div className="single-section" css={singleSectionStyles(color.white)}>
          <FeesGuidelines />
        </div>
        <div className={`"single-section" `} css={singleSectionStyles()}>
          <FAQ
            categories={[
              FAQCategoryEnum.JOINING_PARTNER_FIT,
              FAQCategoryEnum.SCHEDULING_CUSTOMER_SESSIONS,
              FAQCategoryEnum.PAYMENTS,
            ]}
          />
        </div>
      </div>
    </section>
  );
};
